import React from 'react'
import { Link, LinkProps } from 'react-router-dom'
import { createStyles, StyleRules, Theme, withStyles, alpha } from '@material-ui/core/styles'
import MuiButton, { ButtonProps } from '@material-ui/core/Button'

export const buttonStyles = (theme: Theme): StyleRules =>
  createStyles({
    root: {
      textTransform: 'none',
      fontSize: theme.typography.subtitle1.fontSize,
      fontWeight: theme.palette.inputs.label.semibold
    },
    outlined: {
      borderRadius: theme.shape.borderRadius * 2,
      borderColor: theme.palette.grey[200],
      color: theme.palette.inputs.label.color.regular
    },
    contained: {
      backgroundColor: theme.palette.grey[600],
      color: theme.palette.common.white,
      borderRadius: theme.shape.borderRadius * 2,
      '&:hover': {
        backgroundColor: theme.palette.grey[700]
      },
      '&.Mui-disabled': {
        color: alpha(theme.palette.grey[900], 0.8),
        backgroundColor: theme.palette.grey[400]
      }
    },
    containedPrimary: {
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark
      }
    }
  })

export const Button = withStyles(buttonStyles)(MuiButton)

export const TransparentButton = withStyles((theme) => ({
  root: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    color: theme.palette.inputs.label.color.dark,
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
      boxShadow: 'none'
    },
    '&.Mui-disabled': {
      color: alpha(theme.palette.grey[900], 0.8),
      backgroundColor: theme.palette.grey[100]
    }
  }
}))(Button)

export default Button

export type LinkButtonProps = ButtonProps<Link> & LinkProps

export const LinkButton: React.FC<LinkButtonProps> = (props) => <TransparentButton component={Link} {...(props as any)} />
